var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-6 border"},[_c('v-data-table',{staticStyle:{"background-color":"#f8f8f8"},attrs:{"headers":_vm.headers,"items":_vm.shelters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }